"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M21 3H3v18h18zm-6 10h-4v2h4v2H9v-6h4V9H9V7h6z"
}), 'LooksTwoSharp');